import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export interface ChunkUploadInitParams {
  filename: string
  filesize: number
  md5: string
  bizCode: string
  mediaPlatform: string
  storeDomain: string
  firstCategory: string
  totalAdsCount?: number
  activeAdsCount?: number
  spend?: number
  roas?: number
  ctr?: number
  cvr?: number
  data: Blob
}

export interface ChunkUploadChunkParams {
  index: number
  uploadId: string
  bizCode: string
  data: Blob
}

export interface ChunkUploadDoneParams {
  uploadId: string
  bizCode: string
}

export const materialAnalysisChunkUploadApi = defineApi(
  'operation',
  ({ prefix }) => {
    function uploadInit(params: ChunkUploadInitParams) {
      const formData = new FormData()
      formData.append('filename', params.filename)
      formData.append('filesize', String(params.filesize))
      formData.append('md5', params.md5)
      formData.append('bizCode', params.bizCode)
      formData.append('mediaPlatform', params.mediaPlatform)
      formData.append('storeDomain', params.storeDomain)
      formData.append('firstCategory', params.firstCategory)

      if (params.totalAdsCount !== undefined) {
        formData.append('totalAdsCount', String(params.totalAdsCount))
      }
      if (params.activeAdsCount !== undefined) {
        formData.append('activeAdsCount', String(params.activeAdsCount))
      }
      if (params.spend !== undefined) {
        formData.append('mockSpend', String(params.spend))
      }
      if (params.roas !== undefined) {
        formData.append('mockRoas', String(params.roas))
      }
      if (params.ctr !== undefined) {
        formData.append('mockCtr', String(params.ctr))
      }
      if (params.cvr !== undefined) {
        formData.append('mockCvr', String(params.cvr))
      }

      formData.append('data', params.data, params.filename)

      return requestClient
        .post<{
          completed?: boolean
          uploadId?: string
        }>(prefix('chunk-upload/upload-init'), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          return {
            completed: res?.completed === true,
            uploadId: res?.uploadId || '',
          }
        })
    }

    function uploadChunk(params: ChunkUploadChunkParams) {
      const formData = new FormData()
      formData.append('index', String(params.index))
      formData.append('uploadId', params.uploadId)
      formData.append('bizCode', params.bizCode)
      formData.append('data', params.data)

      return requestClient.post(prefix('chunk-upload/upload-chunk'), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    }

    function uploadDone(params: ChunkUploadDoneParams) {
      return requestClient.post(prefix('chunk-upload/upload-done'), {
        uploadId: params.uploadId,
        bizCode: params.bizCode,
      })
    }

    return {
      uploadInit,
      uploadChunk,
      uploadDone,
    }
  },
)
